import Link from "next/link";
import Image from "next/image";

// The Clearline horizontal logo: barcode mark + wordmark, white on transparent
// so it sits on the app's dark surfaces. Intrinsic art is 2175x232 (~9.38:1).
const LOGO_SRC = "/brand/clearline-horizontal.png";
const LOGO_RATIO = 2175 / 232;

// Bare logo image at a given rendered height. Width is derived from the art's
// aspect ratio so it never distorts.
export function BrandMark({
  height = 22,
  className = "",
  priority = false,
}: {
  height?: number;
  className?: string;
  priority?: boolean;
}) {
  return (
    <Image
      src={LOGO_SRC}
      alt="Clearline"
      width={Math.round(height * LOGO_RATIO)}
      height={height}
      priority={priority}
      className={className}
    />
  );
}

// Logo that links home. Used in the primary nav and auth screens.
export function Logo({
  className = "",
  size = "md",
}: {
  className?: string;
  size?: "sm" | "md" | "lg";
}) {
  const height = size === "lg" ? 30 : size === "sm" ? 18 : 22;
  return (
    <Link
      href="/"
      className={`group inline-flex items-center ${className}`}
      aria-label="Clearline home"
    >
      <BrandMark
        height={height}
        className="transition-transform duration-300 group-hover:-translate-y-0.5"
      />
    </Link>
  );
}

// Non-linking wordmark, e.g. inside a footer that already sits under a link.
export function WordmarkGlyph({
  className = "",
  height = 22,
}: {
  className?: string;
  height?: number;
}) {
  return <BrandMark height={height} className={className} />;
}
